import { createSelector } from '@ngrx/store';

import { aiProvidersFeature } from './ai-providers.feature';

export const selectAiProvidersState = aiProvidersFeature.selectAiProvidersState;
export const selectAiProvidersData = createSelector(selectAiProvidersState, (s) => s.aiProviders);
export const selectAiProvidersLoading = aiProvidersFeature.selectLoading;
